export default "__VITE_ASSET__DCVLC40G__"